/**
 * In-memory access JWT only — never persist to localStorage or window globals.
 * Shared by api.ts and env routing helpers (AUTH-003 / AUTH-007).
 */
let memoryAccessToken: string | null = null;

export function setMemoryAccessToken(token: string | null): void {
  memoryAccessToken = typeof token === 'string' && token.trim() ? token.trim() : null;
}

export function getMemoryAccessToken(): string | null {
  return memoryAccessToken;
}

export function clearMemoryAccessToken(): void {
  memoryAccessToken = null;
}
